import types from '@/vuex/tramitacoes/actions-types'
import documentos from '@/utils/documentos'
import dates from '@/utils/dates'
import { removerRascunho, removerRascunhos } from '@/utils/despacho-rascunho'
// import router from '@/router'

const actions = {
  [types.SET_LISTA_TRAMITACOES]: ({ commit }, payload) => {
    commit(types.SET_LISTA_TRAMITACOES, payload)
  },

  [types.GET_LISTA_TRAMITACOES]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tramitações' }, {root: true})
    try {
      commit(types.SET_LISTA_TRAMITACOES, { listaTramitacoes: [] })
      const response = await documentos.getProcessingsList(payload.idDocumento)
      let items = response.data
      var length = items.length
      for (var i = 0; i < length; i++) {
        items[i].dias = dates.daysDiffInteger(items[i].dtDespacho, items[i].dtRecebimento)
      }
      commit(types.SET_LISTA_TRAMITACOES, { listaTramitacoes: items })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar as tramitações' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tramitações' }, {root: true})
    }
  },

  [types.SET_LISTA_FLUXOS]: ({ commit }, payload) => {
    commit(types.SET_LISTA_FLUXOS, payload)
  },

  [types.GET_LISTA_FLUXOS]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando fluxos' }, {root: true})
    try {
      const response = await documentos.getPassosFluxoPossiveisList(payload.idDocumento)
      let items = response.data
      items.sort((a, b) => a.descricao.localeCompare(b.descricao))
      commit(types.SET_LISTA_FLUXOS, { listaFluxos: items })
      commit(types.SET_DESTINO, { destinoSelecionado: undefined })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os fluxos' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando fluxos' }, {root: true})
    }
  },

  [types.SET_FLUXO]: ({ commit }, payload) => {
    commit(types.SET_FLUXO, payload)
  },

  [types.GET_LISTA_FLUXOS_REENCAMINHAMENTO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando fluxos' }, {root: true})
    try {
      const response = await documentos.getPassosFluxoPossiveisReencaminhamentoList(payload.idDocumento)
      let items = response.data
      items.sort((a, b) => a.descricao.localeCompare(b.descricao))
      commit(types.SET_LISTA_FLUXOS, { listaFluxos: items })
      commit(types.SET_DESTINO, { destinoSelecionado: undefined })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os fluxos' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando fluxos' }, {root: true})
    }
  },

  [types.GET_LISTA_DESTINOS_FLUXO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando destinos' }, {root: true})
    try {
      commit(types.SET_DESTINOS_FLUXO, { listaDestinosFluxo: [] })
      const response = await documentos.getDestinosPassoFluxoList(payload.idDocumento, payload.idFluxo)
      commit(types.SET_DESTINOS_FLUXO, { listaDestinosFluxo: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os destinos do fluxo' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando destinos' }, {root: true})
    }
  },

  [types.GET_VALIDACAO_FLUXO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Validando fluxo' }, {root: true})
    try {
      commit(types.SET_VALIDACAO_FLUXO, { listaValidacaoFluxo: {} })
      const response = await documentos.getValidacaoFluxo(payload.idDocumento, payload.idFluxo)
      const regras = []

      Object.keys(response.data).forEach(function (tipo) {
        response.data[tipo].forEach(function (msg) { regras.push({'tipo': tipo, 'msg': msg}) })
      })

      console.log(regras)
      commit(types.SET_VALIDACAO_FLUXO, { listaValidacaoFluxo: regras })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível validar a tramitacao para esse fluxo' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Validando fluxo' }, {root: true})
    }
  },

  [types.SET_DESTINO]: ({ commit }, payload) => {
    commit(types.SET_DESTINO, payload)
  },

  [types.SET_DESPACHO]: ({ commit }, payload) => {
    commit(types.SET_DESPACHO, payload)
  },

  [types.SET_DESPACHO_FORMATADO]: ({ commit }, payload) => {
    commit(types.SET_DESPACHO_FORMATADO, payload)
  },

  [types.GET_DESPACHO_SALVO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando despacho salvo' }, {root: true})
    try {
      const response = await documentos.getDespachoSalvo(payload.idDocumento)
      commit(types.SET_DESPACHO_SALVO, { despachoSalvo: response.data.despacho })
      commit(types.SET_DESPACHO_FORMATADO_SALVO, { despachoFormatadoSalvo: response.data.despachoFormatado })
      commit(types.SET_DESPACHO_PREPARATORIO, { despachoPreparatorio: response.data.despachoPreparatorio })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar o despacho salvo' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando despacho salvo' }, {root: true})
    }
  },

  [types.SALVAR_DESPACHO_TRAMITACAO]: async ({ commit }, payload) => {
    const confirmacaoCallback = async () => {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando despacho' }, {root: true})
      try {
        await documentos.salvarDespacho(payload.idDocumento, payload.despacho, payload.despachoFormatado)
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Despacho salvo com sucesso' }, {root: true})
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível salvar o despacho como padrão' }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando despacho' }, {root: true})
      }
    }
    const config = {
      textoPergunta: 'Salvar o despacho atual?',
      textoConteudo: 'O despacho atual será salvo para ser utilizado especificamente para a tramitação deste documento',
      textoNao: 'Cancelar',
      textoSim: 'Salvar',
      confirmacaoCallback: confirmacaoCallback
    }
    commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
  },

  [types.ENVIAR_TRAMITACAO]: async ({ commit, dispatch }, payload) => {
    const realizarTramitacao = async () => {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Realizando tramitação' }, {root: true})
      try {
        await documentos.enviarTramitacao(payload.documento.idDocumento, payload.fluxo.id, payload.destino.id, payload.despacho, payload.tipoDespacho, payload.nivelAcesso, payload.hipoteseLegal, payload.despachoPreparatorio, payload.despachoFormatado)
        removerRascunho({ idDocumento: payload.documento.idDocumento })
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Tramitação realizada com sucesso' }, {root: true})
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: error.body.message }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Realizando tramitação' }, {root: true})
      }
    }
    if ((payload.documento.situacao === 'EM_CRIACAO') && (payload.documento.idTipo === 571 || payload.documento.idTipoDocumento === 571)) { // Em criação e documento avulso
      let responseListaAnexos = {}
      try {
        commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando existência de peças' }, {root: true})
        responseListaAnexos = await documentos.getListaArquivos(payload.documento.idDocumento)
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Erro ao verificar a existência de peças' }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando existência de peças' }, {root: true})
      }
      if (responseListaAnexos.data.length === 0) {
        const config = {
          textoPergunta: 'Tramitar sem adicionar peças?',
          textoConteudo: 'O documento será tramitado sem possuir nenhuma peça adicionada.',
          textoNao: 'Cancelar',
          textoSim: 'Tramitar'
        }
        if (await dispatch(types.CONFIRMAR, { ...config }, {root: true})) {
          await realizarTramitacao()
          return true
        } else {
          return false
        }
      } else {
        await realizarTramitacao()
        return true
      }
    } else {
      await realizarTramitacao()
      return true
    }
  },

  [types.ENVIAR_TRAMITACAO_MULTIPLA]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Tramitando múltiplos documentos' }, {root: true})
    try {
      const realizarTramitacao = async (documento, fluxo, destino, despacho, tipoDespacho, nivelAcesso, hipoteseLegal, despachoPreparatorio, despachoFormatado) => {
        try {
          await documentos.enviarTramitacao(documento.idDocumento, fluxo.id, destino.id, despacho, tipoDespacho, nivelAcesso, hipoteseLegal, despachoPreparatorio, despachoFormatado)
          return { documento: documento, tramitado: true, error: null }
        } catch (error) {
          return { documento: documento, tramitado: false, error: error }
        }
      }
      const [...results] = await Promise.all(payload.documentos.map(async (documento) => await realizarTramitacao(documento, payload.fluxo, payload.destino, payload.despacho, payload.tipoDespacho, payload.nivelAcesso, payload.hipoteseLegal, payload.despachoPreparatorio, payload.despachoFormatado)))
      if (results.some((result) => result.tramitado)) removerRascunhos()
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Tramitações realizadas com sucesso' }, {root: true})
      return results
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: error.body.message }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Tramitando múltiplos documentos' }, {root: true})
    }
  },

  [types.SET_NIVEL_ACESSO]: ({ commit }, payload) => {
    commit(types.SET_NIVEL_ACESSO, payload)
  },
  [types.GET_LISTA_HIPOTESE_LEGAL]: async({commit}, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando ...' }, {root: true})
    try {
      const response = await documentos.getMotivosRestricoesArquivo()
      commit(types.SET_LISTA_HIPOTESE_LEGAL, { listaHipotesesLegais: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi carregar a lista de hipóteses legais.' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando ...' }, {root: true})
    }
  },
  [types.SET_HIPOTESE_LEGAL]: ({ commit }, payload) => {
    commit(types.SET_HIPOTESE_LEGAL, payload)
  },
  [types.SET_TIPO_DESPACHO]: ({ commit }, payload) => {
    commit(types.SET_TIPO_DESPACHO, payload)
  },
  [types.SET_DESPACHO_PREPARATORIO]: ({ commit }, payload) => {
    commit(types.SET_DESPACHO_PREPARATORIO, payload)
  },
  [types.SET_DESPACHO_SALVO]: ({ commit }, payload) => {
    commit(types.SET_DESPACHO_SALVO, payload)
  },
  [types.SET_DESPACHO_FORMATADO_SALVO]: ({ commit }, payload) => {
    commit(types.SET_DESPACHO_FORMATADO_SALVO, payload)
  },
  [types.SALVAR_DESPACHO_PREPARATORIO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando despacho preparatório' }, {root: true})
    try {
      await documentos.salvarDespachoPreparatorio(payload.idDocumento, payload.despachoPreparatorio)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Despacho preparatório salvo com sucesso' }, {root: true})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível salvar o despacho preparatório' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando despacho preparatório' }, {root: true})
    }
  }
}

export default actions
